import { HeadObjectCommand } from "@aws-sdk/client-s3"
import { SupportedRegions } from "@nova/constants"
import { getS3Client } from "@nova/util-aws-client"
import { getDataBucket } from "./buckets"

export const getObjectSize = async (
    key: string,
    {
        region,
        bucket = getDataBucket(region),
    }: {
        region?: SupportedRegions
        bucket?: string
    } = {}
) => {
    const { ContentLength } = await getS3Client(region).send(
        new HeadObjectCommand({ Bucket: bucket, Key: key })
    )
    return ContentLength ?? null
}
